import { render } from "./Bulk.vue?vue&type=template&id=c5d7f376"
import script from "./Bulk.vue?vue&type=script&lang=js"
export * from "./Bulk.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/lf.m2geo.ie/releases/20261103161156/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Farmer/Bulk.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c5d7f376"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c5d7f376', __exports__)) {
    console.log('reload')
    api.reload('c5d7f376', __exports__)
  }
  
  module.hot.accept("./Bulk.vue?vue&type=template&id=c5d7f376", () => {
    console.log('re-render')
    api.rerender('c5d7f376', render)
  })

}


export default __exports__